<template>
  <el-dialog
    title="本团订单"
    :visible.sync="dialogVisible"
    v-model="dialogVisible"
    :close-on-click-modal="false"
    custom-class="minheight"
    width="90%"
  >
    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      row-key="Id"
    >
      <el-table-column :label="$t('Order.OrderNo')" width="145">
        <template slot-scope="scope">
          {{ scope.row.OrderNo }}
        </template>
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-row :gutter="20" class="remarkRow">
            <el-col :span="2" class="tit">{{ $t("Remark") }}：</el-col>
            <el-col :span="22">{{ scope.row.Remark }}</el-col>
          </el-row>
          <el-row :gutter="20" class="remarkRow">
            <el-col :span="2" class="tit">应支付：</el-col>
            <el-col :span="22" class="text_red"
              >${{ (scope.row.Total + scope.row.Freight).toFixed(2) }}</el-col
            >
          </el-row>
          <el-row
            :gutter="20"
            class="remarkRow"
            v-if="scope.row.KoipyDeduct > 0"
          >
            <el-col :span="2" class="tit">余额支付：</el-col>
            <el-col :span="22" class="text_powder"
              >${{ scope.row.KoipyDeduct }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Freight > 0">
            <el-col :span="2" class="tit">运费：</el-col>
            <el-col :span="22" class="text_red"
              >${{ scope.row.Freight }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Derate > 0">
            <el-col :span="2" class="tit">满减：</el-col>
            <el-col :span="22" class="text_red"
              >-${{ scope.row.Derate }}</el-col
            >
          </el-row>
          <el-row :gutter="20" class="remarkRow" v-if="scope.row.Donate > 0">
            <el-col :span="2" class="tit">返利：</el-col>
            <el-col :span="22" class="text_red">${{ scope.row.Donate }}</el-col>
          </el-row>
          <el-table
            border
            :data="scope.row.OrderItem"
            v-loading="itemListLoading"
            show-summary
            style="width: 1000px"
            size="mini"
          >
            <el-table-column :label="$t('Name')">
              <template slot-scope="scope">{{
                field(scope.row.Name)
              }}</template>
            </el-table-column>
            <el-table-column :label="$t('Spec')">
              <template slot-scope="scope">
                <div
                  class="specItem"
                  v-for="item in scope.row.ProductSpec"
                  :key="item.Id"
                >
                  {{ field(item.Name) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="Number"
              label="数量"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="Price"
              label="单价"
              width="100"
            ></el-table-column>
            <el-table-column prop="Total" :label="$t('Total')" width="100">
              <template slot-scope="scope">
                <span class="text_red">$ {{ scope.row.Total }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('Shop.Name')"
        width="130"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{
          field(scope.row.ShopConfig.Name)
        }}</template>
      </el-table-column>
      <el-table-column :label="$t('Enabled')" width="125">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :class="'text_white state' + scope.row.Status"
            disable-transitions
            >{{ $t("Order.StatusList")[scope.row.Status] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="Total" label="实际支付" width="90">
        <template slot-scope="scope">
          <span class="text_red"
            >$
            {{
              (
                scope.row.Total -
                scope.row.KoipyDeduct +
                scope.row.Freight
              ).toFixed(2)
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="配送时间" width="250">
        <template slot-scope="scope"
          >{{ formatDate(scope.row.ShippingDate) }}
          {{ scope.row.ShippingTime.Name }}：{{
            scope.row.ShippingTime.StartTime
          }}~{{ scope.row.ShippingTime.EndTime }}</template
        >
      </el-table-column>
      <el-table-column
        label="内部备注"
        prop="InternalRemark"
        width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="PayType" :label="$t('PayMode')" width="90">
        <template slot-scope="scope">{{
          $t("Order.PayType." + scope.row.PayType)
        }}</template>
      </el-table-column>
      <el-table-column
        label="收货人"
        prop="Consignee"
        width="130"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        prop="Phone"
        width="100"
      ></el-table-column>
      <el-table-column
        label="收货地址"
        prop="Address"
        width="250"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="邮编" prop="ZipCode" width="70"></el-table-column>
      <el-table-column
        label="备注"
        prop="Remark"
        width="300"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        :label="$t('Order.SubmitTime')"
        prop="DateTime"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">{{
          formatDateTime(scope.row.DateTime)
        }}</template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total,prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <div slot="footer" class="dialog-footer"></div>
  </el-dialog>
</template>

<script>
import util from "util/date";
import { getAllOrderListPage } from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      buttonList: [],
      total: 0,
      list: [],
      page: 1,
      listLoading: false,
      currentRow: null,
      dialogVisible: false,
      tid: 0,
      itemListLoading: false,
    };
  },
  methods: {
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    formatDateTime: function (val) {
      return util.formatDate.format(new Date(val), "MM-dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取列表
    getList() {
      let _this = this;
      this.listLoading = true;
      let para = { tourId: this.tid, page: this.page };
      getAllOrderListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    loadData(id) {
      this.tid = id;
      this.getList();
      this.dialogVisible = true;
    },
  },
};
</script>
<style scoped>
.state101 {
  background-color: mediumblue !important;
}
.state102 {
  background-color: rgb(255, 115, 0) !important;
}
.state201 {
  background-color: orange !important;
}

.state202 {
  background-color: lightcoral !important;
}

.state203 {
  background-color: lightcoral !important;
}

.state204 {
  background-color: lightcoral !important;
}

.state300 {
  background-color: limegreen !important;
}

.state401 {
  background-color: darkgray !important;
}

.state402 {
  background-color: tomato !important;
}

.state403 {
  background-color: darkgray !important;
}
</style>